import React, { useContext } from "react";

import classNames from "classnames";
import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import Link from "next/link";
import { useRouter, usePathname } from "../../hooks/useNavigation";
import PropTypes from "prop-types";

import ComponentContext from "../../../contexts/ComponentContext";
import { useStores } from "../../../contexts/StoreContext";
import { horizontalAlignmentMap } from "../../styles/positionMaps";
import Button from "../Button/Button";

function BrowseAllVacancies(props) {
  const {
    className,
    buttonClassName,
    text,
    buttonColour,
    buttonTextColour,
    buttonHoverColour,
  } = props;

  const { resultsPageHref, buttonText, buttonAlignment } =
    useContext(ComponentContext);

  const { filtersStore } = useStores();
  const { resetAllFilters } = filtersStore;

  const router = useRouter();
  const pathname = usePathname();
  const href = resultsPageHref || pathname.split("?")[0];

  const handleReset = () => {
    router
      .push({
        pathname: href,
      })
      .then(resetAllFilters);
  };

  const buttonWrapperClassName = classNames(
    "d-flex justify-content-center",
    [
      `justify-content-lg-${
        horizontalAlignmentMap[buttonAlignment] || "center"
      }`,
    ],
    { [className]: !isEmpty(className) }
  );

  const buttonClass = classNames(
    "px-5 d-flex justify-content-center align-items-center",
    {
      [buttonClassName]: !isEmpty(buttonClassName),
    }
  );

  return (
    <div className={buttonWrapperClassName}>
      <Link href={href} passHref legacyBehavior>
        <Button
          className={buttonClass}
          onClick={handleReset}
          buttonColour={buttonColour}
          buttonTextColour={buttonTextColour}
          buttonHoverColour={buttonHoverColour}
        >
          {text || buttonText || "Browse all jobs"}
        </Button>
      </Link>
    </div>
  );
}

BrowseAllVacancies.defaultProps = {
  buttonClassName: "",
  className: "",
  text: "",
  buttonColour: "",
  buttonTextColour: "",
  buttonHoverColour: "",
};

BrowseAllVacancies.propTypes = {
  buttonClassName: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string,
  buttonColour: PropTypes.string,
  buttonTextColour: PropTypes.string,
  buttonHoverColour: PropTypes.string,
};

export default observer(BrowseAllVacancies);
